export default __webpack_public_path__ + "static/media/post_pic-orange.dc0d617e.png";